import { useMemo } from 'react'
import { ApolloClient, InMemoryCache } from '@apollo/client'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { createClient as createWsClient } from 'graphql-ws'

import useConfig from '@/gf/hooks/useConfig'
import ApolloWsClientContext from '@/suppliers/contexts/ApolloWsClient'
import useSession from '@/suppliers/hooks/useSession'

const ApolloWsClientProvider = ({ children }: { children: React.ReactNode }) => {
  const config = useConfig()
  const { token } = useSession()

  const client = useMemo(() => {
    const link = new GraphQLWsLink(
      createWsClient({ url: config.suppliersGqlWsUrl, connectionParams: { token } })
    )

    return new ApolloClient({ link, cache: new InMemoryCache() })
  }, [token])

  return <ApolloWsClientContext.Provider value={client}>{children}</ApolloWsClientContext.Provider>
}

export default ApolloWsClientProvider
